const topics = [
  { label: '网红翻车', hot: true },
  { label: '娱乐圈内幕', hot: true },
  { label: '酒店猛料', hot: true },
  { label: '反差视频', hot: true },
  { label: '直播翻车', hot: false },
  { label: '素人爆料', hot: true },
  { label: '选秀黑幕', hot: false },
  { label: '明星恋情', hot: false },
  { label: '片场霸凌', hot: true },
  { label: '数据造假', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          深夜热议话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <span
              key={idx}
              className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-foreground-700 border border-background-300 hover:border-foreground-400'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="text-[10px] opacity-80">🔥</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}